@if (isGroup1Enabled() && getGroup1Field()) {
    <kendo-dropdownlist-wrapper
        [name]="getGroup1Field()"
        [data]="getGroup1Options()"
        [formControlName]="getGroup1Field()"
        [textField]="helpersService.getLang()"
        valueField="Id"
        activeField="IsVisible"
        [label]="getGroup1Caption()"
        [readonly]="!canEditGroup()(getEditGroup1Field())"
        [tooltipIfReadonly]="(type() === CardPanelType.Job ? 'Tooltips.DisabledJobsSecurity' : 'Tooltips.DisabledGroups') | translate"
    />
}
@if (isGroup2Enabled() && getGroup2Field()) {
    <kendo-dropdownlist-wrapper
        [name]="getGroup2Field()"
        [data]="getGroup2Options()"
        [formControlName]="getGroup2Field()"
        [textField]="helpersService.getLang()"
        valueField="Id"
        activeField="IsVisible"
        [label]="getGroup2Caption()"
        [readonly]="!canEditGroup()(getEditGroup2Field())"
        [tooltipIfReadonly]="(type() === CardPanelType.Job ? 'Tooltips.DisabledJobsSecurity' : 'Tooltips.DisabledGroups') | translate"
    />
}
